export const cardWorkspaceEn = {
  "editorHint": "Create a manual card or select a product variant. Save before viewing the print preview.",
  "required": "Required",
  "productDetails": "Product details",
  "linkedProduct": "Linked to product data · Code and Sub Ref are fixed",
  "replaceProduct": "Replace product details?",
  "replaceProductHint": "This replaces Code, Sub Ref, specifications, remarks and image with the selected product. A product without an image clears the current image.",
  "recipient": "Recipient",
  "clearRecipient": "Clear recipient",
  "savedRecipient": "Recipient saved on this card",
  "chooseContact": "Choose from customer contacts",
  "contactEmail": "Contact email",
  "physicalSample": "No image · a physical sample can be attached to the printed card.",
  "printPreview": "Print preview",
  "backToList": "Back to sample cards",
  "viewProduct": "View linked product",
  "viewImage": "View sample image",
  "sourceError": "The selected product could not be loaded. Retry or return to sample cards.",
  "createdFrom": "Created from",
  "createdTo": "Created to",
  "clearFilters": "Clear filters",
  "sample_card_product_unavailable": "The selected product is unavailable. Choose an active product.",
  "sample_card_customer_unavailable": "The selected customer is unavailable. Choose an active customer.",
  "sample_card_identity_locked": "Switch to manual entry before changing the linked Code or Sub Ref.",
  "sample_card_description_required": "Enter a description for this sample card."
};

export const cardWorkspaceVi = {
  "editorHint": "Nhập thẻ thủ công hoặc chọn biến thể sản phẩm. Lưu trước khi xem bản in.",
  "required": "Bắt buộc",
  "productDetails": "Thông tin sản phẩm",
  "linkedProduct": "Đã liên kết danh mục · Code và Sub Ref được cố định",
  "replaceProduct": "Thay thông tin sản phẩm?",
  "replaceProductHint": "Thao tác này thay Code, Sub Ref, quy cách, ghi chú và ảnh bằng sản phẩm đã chọn. Sản phẩm không có ảnh sẽ xóa ảnh hiện tại.",
  "recipient": "Đối tác nhận mẫu",
  "clearRecipient": "Bỏ đối tác nhận mẫu",
  "savedRecipient": "Đối tác đã lưu trên thẻ",
  "chooseContact": "Chọn từ liên hệ khách hàng",
  "contactEmail": "Email liên hệ",
  "physicalSample": "Chưa có ảnh · có thể dán mẫu thật lên thẻ đã in.",
  "printPreview": "Xem trước bản in",
  "backToList": "Về danh sách thẻ mẫu",
  "viewProduct": "Xem sản phẩm đã liên kết",
  "viewImage": "Xem ảnh mẫu",
  "sourceError": "Không tải được sản phẩm đã chọn. Thử lại hoặc quay về danh sách thẻ mẫu.",
  "createdFrom": "Ngày tạo từ",
  "createdTo": "Ngày tạo đến",
  "clearFilters": "Xóa bộ lọc",
  "sample_card_product_unavailable": "Sản phẩm đã chọn không khả dụng. Chọn sản phẩm đang hoạt động.",
  "sample_card_customer_unavailable": "Khách hàng đã chọn không khả dụng. Chọn khách hàng đang hoạt động.",
  "sample_card_identity_locked": "Chuyển sang nhập thủ công trước khi sửa Code hoặc Sub Ref đã liên kết.",
  "sample_card_description_required": "Nhập mô tả cho thẻ mẫu này."
};

export const cardWorkspaceZh = {
  "editorHint": "手动填写样品卡或选择产品规格。保存后即可预览打印。",
  "required": "必填",
  "productDetails": "产品资料",
  "linkedProduct": "已关联产品资料 · 代码及子参考固定",
  "replaceProduct": "取代产品资料？",
  "replaceProductHint": "此操作将以所选产品取代代码、子参考、规格、备注及图片。产品无图片时会清除当前图片。",
  "recipient": "样品收件人",
  "clearRecipient": "清除收件人",
  "savedRecipient": "此样品卡保存的收件人",
  "chooseContact": "从客户联系人选择",
  "contactEmail": "联系邮箱",
  "physicalSample": "无图片 · 可在打印的样品卡上粘贴实物样品。",
  "printPreview": "打印预览",
  "backToList": "返回样品卡列表",
  "viewProduct": "查看关联产品",
  "viewImage": "查看样品图片",
  "sourceError": "无法加载所选产品。请重试或返回样品卡列表。",
  "createdFrom": "创建起始日",
  "createdTo": "创建截止日",
  "clearFilters": "清除筛选",
  "sample_card_product_unavailable": "所选产品无法使用，请选择有效产品。",
  "sample_card_customer_unavailable": "所选客户无法使用，请选择有效客户。",
  "sample_card_identity_locked": "请先切换手动输入，再修改关联的代码或子参考。",
  "sample_card_description_required": "请输入此样品卡的描述。"
};
